<template>
  <div :id="id" class="EchartsMap" />
</template>

<script>
// import { mapTransition } from '@/utils/index'
export default {
  name: 'EchartsMap',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    areaInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      id: `echarts${Number(Math.random().toString().substr(3, 3) + Date.now()).toString(36)}`,
      myEchart: null,
      mTime: null,
      animaFlag: true
    }
  },
  watch: {
    data: {
      handler(val) {
        clearInterval(this.mTime)
        this.dramMap(this.areaInfo.selectedName, this.areaInfo.areaCode, val)
      },
      deep: true
    }
  },
  mounted() {
    this.dramMap('中国', '100000', this.data)
  },
  methods: {
    dramMap(name, code, data) {
      const getMapData = (code) => {
        return require(`@/assets/map/${code}.json`)
      }
      // 根据用户信息对应注册地图
      this.$echarts.registerMap(name, getMapData(code))
      const option = {
        tooltip: {
          show: true
        },
        geo: [
          {
            map: name,
            zlevel: 1,
            aspectScale: 1,
            zoom: 1.25,
            label: {
              show: false
            },
            itemStyle: {
              borderColor: 'rgba(62, 227, 255, 1)',
              borderType: 'solid',
              borderWidth: 2,
              areaColor: 'rgba(5, 153, 182, 1)',
              opacity: 1
            }
          }
        ],
        series: [
          {
            type: 'map',
            map: name,
            zlevel: 3,
            aspectScale: 1,
            zoom: 1.25,
            tooltip: {
              show:false,
            },
            label: {
              show: false
            },
            roam: false,
            itemStyle: {
              borderColor: 'rgba(0, 211, 238, .5)',
              borderType: 'solid',
              borderWidth: 1,
              areaColor: 'rgba(5, 153, 182, 1)',
              shadowBlur: 5,
              shadowColor: 'rgba(58,115,192, .3)',
              shadowOffsetX: 7,
              shadowOffsetY: 6
            },
            emphasis: {
              label: {
                show: false
              },
              itemStyle: {
                areaColor: {
                  type: 'radial',
                  x: 0.5,
                  y: 0.5,
                  r: 1,
                  colorStops: [{
                    offset: 0, color: 'rgba(255, 252, 0, 1)' // 0% 处的颜色
                  }, {
                    offset: 1, color: 'rgba(255, 252, 0, .4)' // 100% 处的颜色
                  }],
                  globalCoord: false // 缺省为 false
                },
                borderColor: '#fecc3e'
              }
            },
            select: {
              label: {
                show: false
              },
              itemStyle: {
                areaColor: { type: 'radial', x: 0.5, y: 0.5, r: 1,
                  colorStops: [{
                    offset: 0, color: 'rgba(238, 205, 58, 1)' // 0% 处的颜色
                  }, {
                    offset: 1, color: 'rgba(238, 205, 58, .4)' // 100% 处的颜色
                  }],
                  globalCoord: false // 缺省为 false
                },
                borderColor: '#fecc3e'
              }
            },
            selectedMode: 'single',
            data: data
          },
          {
            tooltip: {
              trigger: 'item',
              backgroundColor: 'rgba(0, 0, 0, .7)',
              borderColor: 'rgba(0, 0, 0, .7)',
              textStyle: {
                color: '#fff'
              },
              position: function(point, params, dom, rect, size) {
                var x = 0 // x坐标位置
                var y = 0 // y坐标位置
                // 当前鼠标位置
                var pointX = point[0]
                var pointY = point[1]
                // 提示框大小
                var boxWidth = size.contentSize[0]
                var boxHeight = size.contentSize[1]

                // boxWidth > pointX 说明鼠标左边放不下提示框
                if (boxWidth > pointX) {
                  x = pointX + 10
                } else { // 左边放的下
                  x = pointX - boxWidth - 5
                }

                // boxHeight > pointY 说明鼠标上边放不下提示框
                if (boxHeight > pointY) {
                  y = 5
                } else { // 上边放得下
                  y = pointY - boxHeight
                }
                return [x, y]
              },
              formatter: (par) => {
                return par.name + `</br>使用人数: <span style="color:#f4b83e">` + par.data.num + '</span>个'
              }
            },
            type: 'effectScatter',
            coordinateSystem: 'geo',
            zlevel: 3,
            rippleEffect: {
              brushType: 'stroke',
              period: 100000000000000,
              number: 1
            },
            // tooltip: {
            //   show: false
            // },
            label: {
              show: true,
              textStyle: {
                fontSize: 14,
                color: '#fff'
              },
              position: 'top',
              formatter: function(par) {
                return [`{a|${par.name}}`]
              },
              rich: {
                a: {
                  color: '#fff',
                  fontSize: 14,
                  height: 18,
                  backgroundColor: 'rgba(100, 212, 234, .5)',
                  padding: [0, 4],
                  borderColor: 'rgba(100, 212, 234, 1)',
                  borderWidth: 1
                }
              }

            },
            // symbol: `image://${require('@/assets/symbol.png')}`,
            symbolSize: 3,
            itemStyle: {
              color: 'rgba(251, 255, 147, 1)'
            },
            data: data
          }
        ]
      }
      this.myEchart = this.$echarts.init(document.getElementById(this.id))
      this.myEchart.setOption(option, true)
      window.addEventListener('resize', () => {
        this.myEchart.resize()
      })
      this.myEchart.off('click')

      this.myEchart.on('click', params => {
        console.log(params, 11)
        params.code = this.mapTransition(params.name)
        this.$emit('areaClick', params)
        // this.dramMap(params.name, params.code, [])
      })

      // this.myEchart.on('mouseover', params => {
      //   this.animaFlag = false
      // })
      // this.myEchart.on('mouseout', params => {
      //   this.animaFlag = true
      // })

      // var index = 0
      // this.mTime = setInterval(() => {
      //   if (this.animaFlag) {
      //     this.myEchart.dispatchAction({
      //       type: 'select',
      //       seriesIndex: 0,
      //       name: option.series[0].data[index].name
      //     })
      //     this.myEchart.dispatchAction({
      //       type: 'showTip',
      //       seriesIndex: 0,
      //       dataIndex: index
      //     })
      //     index++
      //     if (index >= option.series[0].data.length) {
      //       index = 0
      //     }
      //   }
      // }, 2500)
    },
    resetMapSelect() {
      this.myEchart.dispatchAction({
        type: 'geoUnSelect',
        seriesIndex: 0,
        name: this.selectedName
      })
    },
    reset() {
      this.myEchart.resize()
    },
    mapTransition(key) {
      // switch (key) {
      //   case '湘西土家族苗族自治州':
      //     return '433100'
      //   case '娄底市':
      //     return '431300'
      //   case '怀化市':
      //     return '431200'
      //   case '永州市':
      //     return '431100'
      //   case '郴州市':
      //     return '431000'
      //   case '益阳市':
      //     return '430900'
      //   case '张家界市':
      //     return '430800'
      //   case '常德市':
      //     return '430700'
      //   case '岳阳市':
      //     return '430600'
      //   case '邵阳市':
      //     return '430500'
      //   case '衡阳市':
      //     return '430400'
      //   case '湘潭市':
      //     return '430300'
      //   case '株洲市':
      //     return '430200'
      //   case '长沙市':
      //     return '430100'
      // }
    }
  }
}
</script>

<style scoped lang="scss">
.EchartsMap {
  width: 100%;
  height: 100%;
}
</style>

